import React from 'react';
import styled from 'styled-components';

import { B2BOrder } from '../types';

interface OrderHistoryProps {
  events: B2BOrder['events'];
}

const OrderHistory: React.FC<OrderHistoryProps> = ({ events }) => (
  <Block>
    <Title>История заказа</Title>
    <Timeline>
      {events.length ? (
        [...events].reverse().map((event) => (
          <TimelineItem key={event.id}>
            <i />
            <div>
              <p>{event.title}</p>
              <span>{event.time}</span>
            </div>
          </TimelineItem>
        ))
      ) : (
        <Empty>История заказа пока пуста</Empty>
      )}
    </Timeline>
  </Block>
);

const Block = styled.section`
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;

const Title = styled.h3`
  border-bottom: 1px solid #eceef0;
  font-size: 15px;
  margin: 0;
  padding: 13px 14px;
`;

const Timeline = styled.div`
  max-height: 360px;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 12px 16px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c2c5cc;
    border-radius: 4px;
  }
`;

const TimelineItem = styled.div`
  display: grid;
  gap: 9px;
  grid-template-columns: 13px 1fr;
  min-height: 48px;
  position: relative;

  i {
    background: #fff;
    border: 2px solid #007aff;
    border-radius: 50%;
    height: 9px;
    margin-top: 4px;
    width: 9px;
  }

  &:not(:last-child)::after {
    background: #ced9e5;
    bottom: -4px;
    content: '';
    left: 4px;
    position: absolute;
    top: 15px;
    width: 1px;
  }

  div {
    align-content: start;
    display: grid;
    gap: 4px;
  }

  /* Без жирного, как в логах задач основной CRM (TaskLog). */
  p {
    font-size: 12px;
  }

  span {
    color: #919499;
    font-size: 11px;
  }
`;

const Empty = styled.div`
  color: #919499;
  font-size: 12px;
  line-height: 17px;
`;

export default OrderHistory;
